import { api } from "./client";

const BASE = "/admin/api-keys";

export const apiKeysApi = {
  list: () => api.get(BASE).then((r) => r.data.apiKeys),
  create: ({ name, modules }) =>
    api.post(BASE, { name, modules }).then((r) => r.data),
  revoke: (id) => api.post(`${BASE}/${id}/revoke`).then((r) => r.data.apiKey),
  delete: (id) => api.delete(`${BASE}/${id}`).then((r) => r.data),
};
